export const STATUS_COLORS: Record<string, string> = {
  invited: 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200',
  in_progress: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-200',
  submitted: 'bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-200',
  under_review: 'bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-200',
  approved: 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200',
  rejected: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200',
  more_info_required: 'bg-amber-100 text-amber-800 dark:bg-amber-900 dark:text-amber-200',
  expired: 'bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-200',
};

// 'rejected' is editable too: the supplier fixes their answers and resubmits
// (the onboarding wizard has always offered a Resubmit button for it).
export const EDITABLE_STATUSES = ['invited', 'in_progress', 'more_info_required', 'rejected'];
